import { AccessModel } from "./access";
import { UserInfoModel } from "./user";

export enum AccountType {
	PERSONAL = 1,
	COMPANY = 2,
	FDIR = 3,
}

export interface AccountModel {
	id: string;
	owner: UserInfoModel;
	type: AccountType;
	typeString: string;
	organisationNumber?: string;
	name: string;
	emailAddress: string;
	phoneNumber: string;
	street: string;
	city: string;
	zip: string;
	countryCode: string;
	country: string;
	access: AccessModel;
	createdAt: string;
	updatedAt?: string;
}

export interface AccountInfoModel {
    id: string;
    type: AccountType;
    typeString: string;
    name: string;
}

export interface SwitchAccountModel {
	account: AccountModel;
	accessToken: string;
}